import { lazy } from "react";

const GuiasDespachoLayout = lazy(() =>
      import("../../guias-despacho/GuiasDespachoLayout.jsx")
);

const GuiasDespacho = lazy(() =>
      import("../../guias-despacho/GuiasDespacho.jsx")
);

const GuiaDespachoForm = lazy(() =>
      import("../../guias-despacho/GuiaDespachoForm.jsx")
);

const guiasDespachoRoutes = [
      {
            path: "ventas/guias-despacho",
            element: <GuiasDespachoLayout />,
            children: [
                  { index: true, element: <GuiasDespacho /> },
                  { path: "nueva", element: <GuiaDespachoForm /> },
                  { path: "editar", element: <GuiaDespachoForm /> },
            ],
      },
];

export default guiasDespachoRoutes;
